import { APR } from '@jdiyield/interfaces'
import axios from 'axios'
import BigNumber from 'bignumber.js'

import { StakeFunc } from '../types'
import { safeGasEstimates } from '../utils'

export const stakeKSW: StakeFunc = async ({ web3, pool, walletAddress, amount, contractAddress }) => {
  try {
    //get vault from poolInfo
    const { Izlude, MasterChef, Morroc } = await import('@jdiyield/abi')
    const ct = new web3.eth.Contract(MasterChef.abi as any, contractAddress)
    const poolInfo = await ct.methods.poolInfo(pool).call()
    const vaultAddress = poolInfo['0']
    const vaultContract = new web3.eth.Contract(Izlude as any, vaultAddress)
    const morrocAddress = await vaultContract.methods.morroc().call()
    const morrocContract = new web3.eth.Contract(Morroc as any, morrocAddress)
    const contractWithMethod = morrocContract.methods.deposit(
      new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed()
    )
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })
    return true
  } catch (e) {
    console.log(e)
    return false
  }
}

export const unStakeKSW: StakeFunc = async ({ web3, pool, walletAddress, amount, contractAddress }) => {
  try {
    //get vault from poolInfo
    const { Izlude, MasterChef, Morroc } = await import('@jdiyield/abi')
    const ct = new web3.eth.Contract(MasterChef.abi as any, contractAddress)
    const poolInfo = await ct.methods.poolInfo(pool).call()
    const vaultAddress = poolInfo['0']
    const vaultContract = new web3.eth.Contract(Izlude as any, vaultAddress)
    const morrocAddress = await vaultContract.methods.morroc().call()
    const morrocContract = new web3.eth.Contract(Morroc as any, morrocAddress)
    const contractWithMethod = morrocContract.methods.withdraw(
      new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed()
    )
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })
    return true
  } catch (e) {
    console.log(e)
    return false
  }
}

export const getKillSwitchAPR = async (lpAddress: string): Promise<APR> => {
  try {
    const { data } = await axios.get('https://api.killswitch.finance/ksw/apy')
    const key = findAPRKey(lpAddress)

    const dailyAPR = data[key] ? +data[key].APRD * 100 : 0
    const yearAPY = data[key] ? +data[key].APY * 100 : 0

    return {
      dailyAPR,
      weeklyAPR: dailyAPR * 7,
      monthlyAPR: dailyAPR * 30,
      yearlyAPR: dailyAPR * 365,
      yearAPY: yearAPY
    }
  } catch (err) {
    console.log('getKillSwitchAPR', err)
    return null
  }
}

const findAPRKey = (lpAddress: string) => {
  const addressMapping = {
    // 'definix.FINIX-BUSD': 'definix.FINIX-BUSD',
    // 'definix.FINIX-WBNB': 'definix.FINIX-WBNB',
    // 'definix.SIX-BUSD': 'definix.SIX-BUSD',
    '0xC4B4aC94a73aF2a4788acA0204ce0bE779999dC9': 'definix.SIX-FINIX',
    '0x124166103814E5a033869c88e0F40c61700Fca17': 'dopple.BUSD-USDT',
    '0xAA5509Ce0ecEA324bff504A46Fc61EB75Cb68B0c': 'dopple.BUSD-USDT-DOLLY',
    '0x9116F04092828390799514Bac9986529d70c3791': 'dopple.BUSD-USDT-USDC-DAI',
    '0x7Edcdc8cD062948CE9A9bc38c477E6aa244dD545': 'dopple.BUSD-USDT-UST',
    // 'foodcourt.BUSD-WBNB': 'foodcourt.BUSD-WBNB',
    '0x084bb94e93891D74579B54Ab63ED24C4ef9cd5Ef': 'foodcourt.COUPON',
    '0x52560eBc7920617c9b7328186D1F4A136eAF07F4': 'foodcourt.COUPON-BUSD',
    '0x9d368BA7176F77b2c0abe129eEB1a47B58CDde7E': 'foodcourt.COUPON-WBNB',
    '0x0ed7e52944161450477ee417de9cd3a859b14fd0': 'pancake.CAKE-WBNB',
    // 'robinhood.RBH-BUSD': 'robinhood.RBH-BUSD',
    // 'robinhood.RBH-WBNB': 'robinhood.RBH-WBNB',
    '0xc95b1750043fce5dfcc8539835ea3830ec002a89': 'warden.WAD-BUSD',
    '0xDc683Adb914EdF91df4A36c33EE4f59ca41bC263': 'warden.WAD-WBNB'
  }
  return addressMapping[lpAddress]
}
